import axios, { ResponseType } from 'axios'
import { getUsername } from './getUsername'

const https = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
	headers: {
		apikey: process.env.REACT_APP_API_KEY,
	},
})

const https2 = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
	headers: {
		apikey: process.env.REACT_APP_API_KEY_COUNTER,
	},
})

const fetchGET = async (endpoint: string, configOverride: object | null = null) => {
	const { username, accessToken } = await getUsername()

	let config = {
		headers: {
			email: username,
			token: accessToken,
		},
	}

	if (configOverride !== null) {
		config = { ...config, ...configOverride };
	}

	const response = await https.get(endpoint, config)
	return response
}

const fetchGETCounter = async (endpoint: string, configOverride: object | null = null) => {
	const { username, accessToken } = await getUsername()

	let config = {
		headers: {
			email: username,
			token: accessToken,
		},
	}

	if (configOverride !== null) {
		config = { ...config, ...configOverride };
	}

	const response = await https2.get(endpoint, config)
	return response
}

const fetchGETCounterSys = async (endpoint: string, configOverride: object | null = null) => {
	const { username, accessToken } = await getUsername()

	let config = {
		headers: {
			token: accessToken,
		},
	}

	if (configOverride !== null) {
		config = { ...config, ...configOverride };
	}

	const response = await https2.get(endpoint, config)
	return response
}

const fetchGETSYS = async (endpoint: string, configOverride: object | null = null) => {
	const { accessToken } = await getUsername()

	let config = {
		headers: {
			token: accessToken,
		},
	}

	if (configOverride !== null) {
		config = { ...config, ...configOverride };
	}

	const response = await https.get(endpoint, config)
	return response
}

const fetchPOST = async (endpoint: string, data: any) => {
	const { username, accessToken } = await getUsername()

	let config = {
		headers: {
			email: username,
			token: accessToken
		},
	}

	const response = await https.post(endpoint, data, config)
	return response
}

const fetchPOST2Blob = async (endpoint: string, data: any) => {
	const { accessToken, username } = await getUsername()
	let config = {
		headers: {
			email: username,
			token: accessToken,
		},
		responseType: 'blob' as ResponseType,
	}

	const response = await https.post(endpoint, data, config)
	return response
}

const fetchPOSTWithOutEmailBlob = async (endpoint: string, data: any) => {
	const { accessToken } = await getUsername()
	let config = {
		headers: {
			token: accessToken,
		},
		responseType: 'blob' as ResponseType,
	}

	const response = await https.post(endpoint, data, config)
	return response
}

const fetchPOSTWithoutEmail = async (endpoint: string, data: any) => {
	const { accessToken } = await getUsername()

	let config = {
		headers: {
			token: accessToken
		},
	}

	const response = await https.post(endpoint, data, config)
	return response
}

export {
	fetchGET, fetchGETCounter,
	fetchGETCounterSys, fetchGETSYS, fetchPOST, fetchPOST2Blob, fetchPOSTWithoutEmail, fetchPOSTWithOutEmailBlob
}

